/**
 * React component that is responsible for rendering a "course summary" card.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react';
import PropTypes from 'prop-types'
import cx from 'classnames'
import Button from 'components/theme/Button'
import Typography from 'components/theme/Typography'
import styles from './CourseCard.module.scss'

const CourseCard = ({
  className,
  title,
  choose,
  time,
  cost,
  linkText,
  href,
}) => (
  <div className={cx(styles.courseCard, className)}>
    <div className={cx(styles.courseHeader)}>
      <Typography variant="h1" align="center">{title}</Typography>
    </div>
    <div className={cx(styles.courseBody)}>
      <div className={cx('mb-xl')}>
        <Typography variant="h3">{choose?.title}</Typography>
        <Typography variant="d2" fontWeight={400}>{choose?.value}</Typography>
      </div>
      <div className={cx('mb-xl')}>
        <Typography variant="h3">{time?.title}</Typography>
        <Typography variant="h1" fontWeight={400}>{time?.value}</Typography>
      </div>
      <div className={cx('mb-xl')}>
        <Typography variant="h3">{cost?.title}</Typography>
        <Typography variant="h1" fontWeight={400}>{cost?.value}</Typography>
      </div>
      <div className={cx('mt-auto')}>
        <a href={href}>
          <Button variant="outline-secondary">
            {linkText}
          </Button>
        </a>
      </div>
    </div>
  </div>
)

CourseCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  choose: PropTypes.object,
  time: PropTypes.object,
  cost: PropTypes.object,
  linkText: PropTypes.string,
  href: PropTypes.string,
}

export default CourseCard
